<template>
  <v-tooltip bottom max-width="320">
    <template v-slot:activator="{ on, attrs }">
      <v-chip x-small outlined color="warning" v-bind="attrs" v-on="on">
        <v-icon left x-small>mdi-account-clock</v-icon>
        Provizoriu
      </v-chip>
    </template>
    <span>
      Rating provizoriu: {{ ratedSessions }} din {{ requiredSessions }} curse clasate.
      {{ remainingText }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'RlrProvisionalChip',
  props: {
    ratedSessions: {
      type: Number,
      required: true
    },
    requiredSessions: {
      type: Number,
      default: 5
    }
  },
  computed: {
    remainingSessions() {
      return Math.max(this.requiredSessions - this.ratedSessions, 0)
    },
    remainingText() {
      if (this.remainingSessions === 1) {
        return 'Mai este necesară o cursă pentru stabilizarea ratingului.'
      }
      return `Mai sunt necesare ${this.remainingSessions} curse pentru stabilizarea ratingului.`
    }
  }
}
</script>
